import { useDataProvider } from "ra-core";
import { useMemo, type ReactNode } from "react";
import { getSupabaseClient } from "@/components/atomic-crm/providers/supabase/supabase";
import { IS_DEMO } from "../../env";
import { ReportsClientProvider } from "../ReportsClientContext";
import { createLocalReportsClient } from "./localReportsClient";
import {
  createSupabaseReportsClient,
  type RpcClient,
} from "./supabaseReportsClient";

/** RPCs on Supabase; local computation in the FakeRest demo. */
export const DefaultReportsClientProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const dataProvider = useDataProvider();
  const client = useMemo(
    () =>
      IS_DEMO
        ? createLocalReportsClient(dataProvider)
        : createSupabaseReportsClient(
            getSupabaseClient as unknown as () => RpcClient,
          ),
    [dataProvider],
  );
  return (
    <ReportsClientProvider client={client}>{children}</ReportsClientProvider>
  );
};
